import { SimpleGrid, SimpleGridProps } from "@chakra-ui/layout"
import React from "react"

import { SpacingSize } from "~/consts/style-mixins"
import { useMobileMedia } from "~/hooks/useMobileMedia"

type Props = SimpleGridProps

/** pcの時は2列、mobile時は1列、縦に2つ表示する(原則childrenは2つの要素を入れる) */
export const DoubleColumnsGrid: React.FC<Props> = ({ children, spacing }) => {
  const isMobile = useMobileMedia()
  return (
    <SimpleGrid w="100%" columns={isMobile ? 1 : 2} spacing={isMobile ? SpacingSize._2XL : spacing ?? SpacingSize.XS}>
      {children}
    </SimpleGrid>
  )
}
